import { render, staticRenderFns } from "./KategoriDuzenle.vue?vue&type=template&id=00e1c00d&scoped=true&"
import script from "./KategoriDuzenle.vue?vue&type=script&lang=js&"
export * from "./KategoriDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./KategoriDuzenle.vue?vue&type=style&index=0&id=00e1c00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e1c00d",
  null
  
)

export default component.exports